"use strict";

var _defineProperty = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/defineProperty.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexItem = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = require("@emotion/react");

var FlexItemElement = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var order = props.order,
      grow = props.grow,
      shrink = props.shrink,
      basis = props.basis,
      alignSelf = props.alignSelf,
      onClick = props.onClick;
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\torder: ", ";\n\t\t\tflex: ", " ", " ", ";\n\t\t\tcursor: ", ";\n\t\t\talign-self: ", ";\n\t\t"])), order, grow, shrink, basis, !!onClick ? "pointer" : "inherit", alignSelf);
});

var FlexItem = function FlexItem(_ref) {
  var _ref2;

  var children = _ref.children,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order,
      _ref$grow = _ref.grow,
      grow = _ref$grow === void 0 ? 0 : _ref$grow,
      _ref$shrink = _ref.shrink,
      shrink = _ref$shrink === void 0 ? 1 : _ref$shrink,
      _ref$basis = _ref.basis,
      basis = _ref$basis === void 0 ? "auto" : _ref$basis,
      _ref$alignSelf = _ref.alignSelf,
      alignSelf = _ref$alignSelf === void 0 ? "auto" : _ref$alignSelf,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style,
      itemRef = _ref.itemRef,
      onClick = _ref.onClick;
  return (0, jsx_runtime_1.jsx)(FlexItemElement, (_ref2 = {
    order: order,
    grow: grow,
    shrink: shrink,
    basis: basis,
    alignSelf: alignSelf,
    onClick: onClick,
    css: style,
    className: className,
    ref: itemRef
  }, _defineProperty(_ref2, "onClick", onClick), _defineProperty(_ref2, "children", children), _ref2));
};

exports.FlexItem = FlexItem;